import type { ReactNode } from 'react';
import { FiAlertCircle, FiCheckCircle, FiInfo, FiAlertTriangle } from 'react-icons/fi';
import { cn } from '../../lib/cn';

type Variant = 'info' | 'sucesso' | 'aviso' | 'erro';

const VARIANTS: Record<Variant, { bg: string; border: string; text: string; Icone: typeof FiInfo }> = {
  info:    { bg: 'bg-blue-50',    border: 'border-blue-200',    text: 'text-blue-900',    Icone: FiInfo },
  sucesso: { bg: 'bg-emerald-50', border: 'border-emerald-200', text: 'text-emerald-900', Icone: FiCheckCircle },
  aviso:   { bg: 'bg-amber-50',   border: 'border-amber-200',   text: 'text-amber-900',   Icone: FiAlertTriangle },
  erro:    { bg: 'bg-red-50',     border: 'border-red-200',     text: 'text-red-900',     Icone: FiAlertCircle },
};

export function Alert({ variante, children, className }: { variante: Variant; children: ReactNode; className?: string }) {
  const { bg, border, text, Icone } = VARIANTS[variante];
  return (
    <div className={cn('flex items-start gap-3 px-4 py-3 rounded-md border text-sm', bg, border, text, className)}>
      <Icone size={16} className="flex-shrink-0 mt-0.5" />
      <div className="flex-1">{children}</div>
    </div>
  );
}
